// SPDX-License-Identifier: Elastic-2.0
/**
 * Root-route loader (T-004).
 *
 * Sends the user to the right starting point based on guard state when
 * they hit `/`. Using a loader (vs a component-level `<Navigate>`)
 * avoids a render flash on first paint.
 *
 * Kept in its own non-JSX module so it doesn't tempt anyone into
 * mixing loaders with components in `router.tsx` (Fast Refresh would
 * complain) and so it can be unit-tested in isolation later.
 */
import { redirect } from "react-router-dom";
import { ROUTES } from "./routes";
import { isOnboardingComplete } from "./onboardingState";
import { getStoredJwt, getStoredDeviceId } from "./tokenStorage";

export function rootIndexLoader(): Response {
  if (!isOnboardingComplete()) {
    return redirect(ROUTES.ONBOARDING);
  }
  // A usable identity is either a cloud JWT or an account-less device_id
  // (Free tier, F-348). Only a truly identity-less install is sent to
  // pairing; account-less installs go straight to the dashboard.
  if (!getStoredJwt() && !getStoredDeviceId()) {
    return redirect(`${ROUTES.ONBOARDING_ACCOUNT}?reauth=true`);
  }
  return redirect(ROUTES.DASHBOARD);
}
